// Sites that keep the same favicon on dark mode (no white variants).
const KEEP_FAVICON_HOSTS = ['wardsauto', 'techtarget', 'socialmediatoday', 'pharmavoice'];

document.addEventListener('DOMContentLoaded', () => {
  if (KEEP_FAVICON_HOSTS.some((host) => window.location.hostname.includes(host))) {
    return;
  }
  const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
  if (isDarkMode) {
    const iconMap = {
      '/favicon.ico?v=3': '/white-favicon.ico?v=3',
      '/favicon-32x32.png?v=3': '/white-favicon-32x32.png?v=3',
      '/favicon-16x16.png?v=3': '/white-favicon-16x16.png?v=3',
    };

    const iconLinks = document.querySelectorAll('link[rel="icon"]');

    iconLinks.forEach((link) => {
      const currentHref = link.getAttribute('href');
      Object.entries(iconMap).forEach(([light, dark]) => {
        if (currentHref === light) {
          link.setAttribute('href', dark);
        }
      });
    });
  }
});
